import { fhirUrls } from "@/templates/fhir-urls";

export const compositionTemplate = {
  resourceType: "Composition",
  status: "preliminary",

  type: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  date: null,
  author: [{ reference: null }],
  title: null,
  subject: {
    reference: null
  },
  encounter: {
    reference: null
  },
  section: []
};

export const listTemplate = {
  resourceType: "List",
  status: null,
  mode: null,
  code: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  subject: {
    reference: null
  },
  encounter: {
    reference: null
  },
  source: {
    reference: null
  },
  entry: [
    {
      item: {
        reference: null
      }
    }
  ]
};

export const encounterTemplate = {
  resourceType: "Encounter",
  status: null,
  class: {
    system: null,
    code: null,
    display: null
  },
  type: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  subject: {
    reference: null
  },
  partOf: {
    reference: null
  }
};

export const commentTemplate = {
  resourceType: "Observation",
  extension: [
    {
      url: "http://hl7.org/fhir/StructureDefinition/workflow-episodeOfCare",
      valueReference: {
        reference: null
      }
    }
  ],
  status: "final",
  code: {
    coding: [
      {
        system: "http://molit.eu/fhir/vitu/CodeSystem/note-types",
        code: "tumor-board-preparation",
        display: "Tumorboard Vorbereitung"
      },
      {
        system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        code: "C42619",
        display: "Note"
      }
    ],
    text: "Vorbereitungsnotiz"
  },
  subject: {
    reference: null
  },
  performer: [
    {
      display: null
    }
  ],
  effectiveDateTime: null,
  valueString: null
};

export const observationTemplate = {
  resourceType: "Observation",
  status: null,
  code: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ],
    text: null
  },
  subject: {
    reference: null
  },
  encounter: {
    reference: null
  },
  performer: [
    {
      reference: null
    }
  ],
  effectiveDateTime: null,
  valueCodeableConcept: {},
  valueString: null
};

export const valueCodeableConceptTemplate = {
  coding: [
    {
      system: null,
      code: null,
      display: null
    }
  ]
};

export const conditionTemplate = {
  resourceType: "Condition",
  clinicalStatus: {
    coding: [
      {
        system: null,
        code: null
      }
    ]
  },
  code: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  subject: {},
  onsetDateTime: null,
  note: [
    {
      text: null
    }
  ]
};

export const procedureTemplate = {
  resourceType: "Procedure",
  extension: [
    {
      url: null,
      valueReference: {
        reference: null
      }
    }
  ],
  status: null,
  category: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  code: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  subject: {
    reference: null
  },
  performedDateTime: null,
  performedPeriod: {
    start: null,
    end: null
  },
  reasonReference: [
    {
      reference: null
    }
  ]
};

export const medicationStatementTemplate = {
  resourceType: "MedicationStatement",
  status: null,
  medicationCodeableConcept: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  subject: {
    reference: null
  },
  context: {
    reference: null
  },
  effectivePeriod: {
    start: null,
    end: null
  },
  reasonReference: [
    {
      reference: null
    }
  ]
};

export const documentReferenceTemplate = {
  resourceType: "DocumentReference",
  status: null,
  type: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  subject: {
    reference: null
  },
  author: {
    reference: null
  },
  content: [
    {
      attachment: {
        id: null,
        contentType: null,
        url: null
      }
    }
  ]
};

export const consentTemplate = {
  resourceType: "Consent",
  status: "",
  scope: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  category: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  patient: {
    reference: null
  },
  dateTime: null,
  policyRule: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  }
};

export const taskTemplate = {
  resourceType: "Task",
  status: "in-progress",
  for: {
    reference: null,
    display: null
  },
  input: [
    {
      valueReference: {
        reference: null
      }
    }
  ],
  code: {
    coding: [
      {
        system: "http://molit.eu/fhir/vitu/CodeSystem/vitu-task",
        code: "mtb-task",
        display: "MTB Task"
      }
    ],
    text: "MTB Task"
  },
  businessStatus: {
    coding: [
      {
        system: "http://molit.eu/fhir/vitu/CodeSystem/working-list-status",
        code: null,
        display: null
      }
    ],
    text: null
  }
};

export const reasonCancelledExtension = {
  url: "http://molit.eu/fhir/StructureDefinition/reason-cancelled",
  extension: [
    {
      url: "codedReason",
      valueCodeableConcept: {
        coding: [
          {
            system: "http://molit.eu/fhir/vitu/CodeSystem/tumorboard-cancellation-reason",
            code: null
          }
        ]
      }
    },
    {
      url: "otherReason",
      valueString: null
    }
  ]
};

export const patientTemplate = {
  resourceType: "Patient",
  identifier: [],
  active: true,
  name: [
    {
      use: "official",
      family: null,
      given: []
    }
  ],
  gender: null,
  birthDate: null
};

export const episodeofCareTemplate = {
  resourceType: "EpisodeOfCare",
  identifier: [],
  patient: {
    reference: null,
    display: null
  },
  diagnosis: [
    {
      condition: {
        display: null
      }
    }
  ]
};

export const binaryTemplate = {
  resourceType: "Binary",
  contentType: null,
  data: null
};

export const documentReference = {
  resourceType: "DocumentReference",
  status: "current",
  type: {
    coding: [
      {
        system: null,
        code: null,
        display: null
      }
    ]
  },
  subject: {
    reference: null
  },
  content: [
    {
      attachment: {
        id: null,
        contentType: null,
        url: null
      }
    }
  ]
};

export const transactionGetCaseOverviewResources = {
  resourceType: "Bundle",
  type: "transaction",
  entry: [
    {
      request: {
        method: "GET",
        url: "ValueSet/$expand?url=" + fhirUrls.WORKING_LIST_STATUS
      }
    },
    {
      request: {
        method: "GET",
        url: "ValueSet/$expand?url=" + fhirUrls.TUMORBOARD_CANELLATION_REASON
      }
    },
    {
      request: {
        method: "GET",
        url: "ValueSet/$expand?url=" + fhirUrls.BIOMARKER
      }
    },
    {
      request: {
        method: "GET",
        url: "ValueSet/$expand?url=" + fhirUrls.TREATMENT_CONTEXT
      }
    },
    {
      request: {
        method: "GET",
        url: "ValueSet/$expand?url=" + fhirUrls.RECOMMENDATION_CATEGORY
      }
    },
    {
      request: {
        method: "GET",
        url: "ValueSet/$expand?url=" + fhirUrls.EVIDENCE_LEVEL
      }
    }
  ]
};

export const transactionPostCompostionTemplate = {
  resourceType: "Bundle",
  type: "transaction",
  entry: []
};

export const transactionTemplate = {
  resourceType: "Bundle",
  type: "transaction",
  entry: []
};

export const transactionPostPatientTemplate = {
  resourceType: "Bundle",
  type: "transaction",
  entry: [
    {
      fullUrl: null,
      resource: null,
      request: {
        method: "POST",
        url: "EpisodeOfCare"
      }
    },
    {
      fullUrl: null,
      resource: null,
      request: {
        method: "POST",
        url: "Patient"
      }
    },
    {
      fullUrl: null,
      resource: null,
      request: {
        method: "POST",
        url: "Task"
      }
    }
  ]
};

export const transactionPutPatientTemplate = {
  resourceType: "Bundle",
  type: "transaction",
  entry: [
    {
      resource: null,
      request: {
        method: "PUT",
        url: "EpisodeOfCare/"
      }
    },
    {
      resource: null,
      request: {
        method: "PUT",
        url: "Patient/"
      }
    }
  ]
};

export const transactionPostTemplate = {
  resourceType: "Bundle",
  type: "transaction",
  entry: [
    {
      fullUrl: null,
      resource: null,
      request: {
        method: "POST",
        url: "EpisodeOfCare"
      }
    },
    {
      fullUrl: null,
      resource: null,
      request: {
        method: "POST",
        url: "Task"
      }
    }
  ]
};

export const transactionDeleteTemplate = {
  resourceType: "Bundle",
  type: "transaction",
  entry: [
    {
      request: {
        method: "DELETE",
        url: "EpisodeOfCare/"
      }
    },
    {
      request: {
        method: "DELETE",
        url: "Task/"
      }
    }
  ]
};

export const transactionPutTemplate = {
  resourceType: "Bundle",
  type: "transaction",
  entry: [
    {
      resource: null,
      request: {
        method: "PUT",
        url: "EpisodeOfCare/"
      }
    },
    {
      resource: null,
      request: {
        method: "PUT",
        url: "Task/"
      }
    }
  ]
};

export const statusTemplate = {
  extension: [
    {
      url: "http://hl7.org/fhir/StructureDefinition/ordinalValue",
      valueDecimal: null
    }
  ],
  code: null,
  display: null
};

export const organizationTemplate = {
  resourceType: "Organization",
  name: null,
  active: true,
  partOf: null,
  contact: [],
  address: []
};

export const courseOfDiseaseTemplate = {
  resourceType: "Observation",
  status: "final",
  code: {
    coding: [
      {
        system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        code: "C17747",
        display: "Disease Progression"
      }
    ],
    text: "Disease Progression"
  },
  subject: {
    reference: ""
  },
  effectiveDateTime: "",
  valueCodeableConcept: {
    coding: [
      {
        system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        code: "",
        display: ""
      }
    ]
  }
};

export const recommendationListTemplate = {
  resourceType: "List",
  status: "current",
  mode: "working",
  code: {
    coding: [
      {
        system: "http://loinc.org",
        code: "93341-6",
        display: "Medication recommendation"
      }
    ]
  },
  subject: {
    reference: ""
  },
  entry: [
    {
      item: {
        reference: ""
      }
    }
  ]
};

export const recommendationReasonTemplate = {
  resourceType: "Observation",
  status: "final",
  code: {
    coding: [
      {
        system: "http://loinc.org",
        code: "93341-6",
        display: "Medication recommendation"
      }
    ]
  },
  subject: {
    reference: ""
  },
  valueCodeableConcept: {
    coding: [
      {
        system: "http://www.whocc.no/atc",
        code: "L01BB05",
        display: "Fludarabin"
      }
    ]
  },
  component: [
    {
      code: {
        coding: [
          {
            system: "http://loinc.org",
            code: "93044-6",
            display: "Level of evidence"
          }
        ]
      },
      valueCodeableConcept: {
        coding: [
          {
            system: "http://molit.eu/fhir/vitu/CodeSystem/evidence-level",
            code: "m1B",
            display: "In der gleichen Tumorentität wurde der prädiktive Wert des Biomarkers oder die klinische Wirksamkeit in einer retrospektiven Kohorte oder Fall-Kontroll-Studie gezeigt."
          }
        ]
      }
    }
  ]
};

export const recommendationStatementTemplate = {
  resourceType: "MedicationRequest",
  status: "draft",
  statusReason: {
    coding: [
      {
        system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        code: "C35571",
        display: "Progrediente Erkrankung"
      }
    ]
  },
  intent: "plan",
  medicationReference: {
    reference: "Medication/d46c0116-7756-4a10-be45-04dffffa9e30"
  },
  subject: {
    reference: ""
  },
  authoredOn: new Date().toISOString(),
  reasonCode: [
    {
      coding: [
        {
          system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
          code: "C28237",
          display: "Leitlinie"
        }
      ]
    }
  ],
  reasonReference: [
    {
      reference: "Observation/ff4ec90b-a478-45df-b9fc-a86c3d680be2"
    }
  ]
};

export const recommendationMedicationTemplate = {
  resourceType: "Medication",
  status: "active",
  ingredient: [
    {
      itemCodeableConcept: {
        coding: [
          {
            system: "http://molit.eu/fhir/CodeSystem/protocol-list",
            code: "folfirinox",
            display: "Folfirinox"
          }
        ]
      }
    },
    {
      itemCodeableConcept: {
        coding: [
          {
            system: "http://www.whocc.no/atc",
            code: "L01BB05",
            display: "Fludarabin"
          }
        ]
      }
    }
  ]
};

export const cdsSuggestResearchStudiesTemplate = {
  hookInstance: "88f0dc37-e374-4bbd-8927-124b287ca092",
  fhirServer: null,
  hook: "suggestResearchStudies",
  user: "Practitioner/123",
  context: {
    userId: "Practitioner/123"
  },
  prefetch: {
    patient: null,
    condition: null,
    subtype: null,
    uicc: null,
    variants: []
  }
};

export const consentDatenspendeTemplate = {
  resourceType: "Consent",
  meta: {
    profile: ["http://molit.eu/fhir/vitu/StructureDefinition/vitu-consent-data-donation"]
  },
  text: {
    status: "extensions",
    div: '<div xmlns="http://www.w3.org/1999/xhtml"><p><b>Generated Narrative</b></p><p><b>ADT-Treatment-Action</b>: <a href="EpisodeOfCare-Tumorerkrankung.html">Generated Summary: Medical record number: 4634834, vitu-episodeOfCare-identifier: Z123456780; status: active; <span title="Codes: {http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl C16213}">Cancer Diagnosis</span></a></p><p><b>status</b>: active</p><p><b>scope</b>: <span title="Codes: {http://terminology.hl7.org/CodeSystem/consentscope research}">Research</span></p><p><b>category</b>: <span title="Codes: {http://loinc.org 59284-0}">Patient Consent</span></p><p><b>patient</b>: <a href="Patient-Beispielpatient.html">Generated Summary: Patient external identifier: 654321, Patient internal identifier: 876456X123; active; Maximilian Peter Mustermann (OFFICIAL); gender: male; birthDate: 1974-12-25</a></p><p><b>dateTime</b>: Feb 7, 2016, 6:28:17 PM</p><h3>Policies</h3><table class="grid"><tr><td>-</td><td><b>Uri</b></td></tr><tr><td>*</td><td><a href="http://molit.eu/fhir/Consents/Datenspende/Einwilligungserklärung_V1.0_Druck_3mm.pdf">http://molit.eu/fhir/Consents/Datenspende/Einwilligungserklärung_V1.0_Druck_3mm.pdf</a></td></tr></table><blockquote><p><b>provision</b></p><p><b>type</b>: deny</p><h3>Provisions</h3><table class="grid"><tr><td>-</td><td><b>Type</b></td><td><b>Action</b></td></tr><tr><td>*</td><td>permit</td><td><span title="Codes: {http://molit.eu/fhir/vitu/CodeSystem/consent-code-molit-datenspende DS}">Datenspende</span></td></tr><tr><td>*</td><td>permit</td><td><span title="Codes: {http://molit.eu/fhir/vitu/CodeSystem/consent-code-molit-datenspende RFWI}">Rückfragen wissenschaftliche Informationen</span></td></tr><tr><td>*</td><td>permit</td><td><span title="Codes: {http://molit.eu/fhir/vitu/CodeSystem/consent-code-molit-datenspende ZB}">Kontakterlaubnis Zusatzbefunde</span></td></tr></table></blockquote></div>'
  },
  extension: [
    {
      url: "http://molit.eu/fhir/vitu/StructureDefinition/episode-of-care",
      valueReference: {
        reference: "EpisodeOfCare/Tumorerkrankung"
      }
    }
  ],
  status: "active",
  scope: {
    coding: [
      {
        system: "http://terminology.hl7.org/CodeSystem/consentscope",
        code: "research",
        display: "Research"
      }
    ]
  },
  category: [
    {
      coding: [
        {
          system: "http://loinc.org",
          code: "59284-0",
          display: "Patient Consent"
        }
      ]
    }
  ],
  patient: {
    reference: null
  },
  dateTime: null,
  policy: [
    {
      uri: "http://molit.eu/fhir/Consents/Datenspende/Einwilligungserklärung_V1.0_Druck_3mm.pdf"
    }
  ],
  provision: {
    type: "deny",
    provision: [
      {
        type: null,
        action: [
          {
            coding: [
              {
                system: "http://molit.eu/fhir/vitu/CodeSystem/consent-code-molit-datenspende",
                code: "DS",
                display: "Datenspende"
              }
            ]
          }
        ]
      },
      {
        type: null,
        action: [
          {
            coding: [
              {
                system: "http://molit.eu/fhir/vitu/CodeSystem/consent-code-molit-datenspende",
                code: "RFWI",
                display: "Rückfragen wissenschaftliche Informationen"
              }
            ]
          }
        ]
      },
      {
        type: null,
        action: [
          {
            coding: [
              {
                system: "http://molit.eu/fhir/vitu/CodeSystem/consent-code-molit-datenspende",
                code: "ZB",
                display: "Kontakterlaubnis Zusatzbefunde"
              }
            ]
          }
        ]
      }
    ]
  }
};

export const importantVariantsTemplate = {
  resourceType: "List",
  extension: [
    {
      url: "http://molit.eu/fhir/vitu/StructureDefinition/diagnostic-report-reference",
      valueReference: null
    }
  ],
  status: "current",
  mode: "working",
  code: {
    coding: [
      {
        system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        code: "C115916",
        display: "Important"
      }
    ]
  },
  subject: {
    reference: null
  },
  entry: []
};

export const hrdScore = {
  resourceType: "Observation",
  meta: {
    profile: ["http://molit.eu/fhir/vitu/StructureDefinition/hrd-score"]
  },
  extension: [
    {
      url: "http://molit.eu/fhir/vitu/StructureDefinition/episode-of-care",
      valueReference: {
        reference: null
      }
    }
  ],
  status: "final",
  code: {
    coding: [
      {
        system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        code: "C120465"
      }
    ]
  },
  subject: {
    reference: null
  },
  effectiveDateTime: null,
  valueInteger: null
};

export const msiScore = {};

export const tmbScore = {
  resourceType: "Observation",
  meta: {
    profile: ["http://hl7.org/fhir/uv/genomics-reporting/StructureDefinition/tmb"]
  },
  status: "final",
  extension: [
    {
      url: "http://molit.eu/fhir/vitu/StructureDefinition/episode-of-care",
      valueReference: {
        reference: null
      }
    }
  ],
  category: [
    {
      coding: [
        {
          system: "http://terminology.hl7.org/CodeSystem/observation-category",
          code: "laboratory"
        }
      ]
    }
  ],
  code: {
    coding: [
      {
        system: "http://loinc.org",
        code: "94076-7"
      }
    ]
  },
  subject: {
    reference: null
  },
  effectiveDateTime: null,
  valueQuantity: {
    value: null,
    system: "http://unitsofmeasure.org",
    code: "1/1000000{Base}"
  }
};

export const therapyRecommendationList = {
  resourceType: "List",
  extension: [
    {
      url: "http://molit.eu/fhir/vitu/StructureDefinition/episode-of-care",
      valueReference: {
        reference: null
      }
    }
  ],
  status: "current",
  mode: "working",
  code: {
    coding: [
      {
        system: "http://loinc.org",
        code: "93341-6",
        display: "Medication recommendation"
      }
    ]
  },
  subject: {
    reference: null
  },
  entry: []
};

export const therapyRecommendationBundle = {
  resourceType: "Bundle",
  id: "TherapyRecommendationExample",
  type: "transaction",
  entry: [
    {
      fullUrl: "2f4b2548-71d6-48dd-81eb-067538ace523",
      resource: {
        resourceType: "List",
        id: "TherapyRecommendationListExample",
        text: {
          status: "extensions",
          div: '<div xmlns="http://www.w3.org/1999/xhtml"><p><b>Generated Narrative</b></p><p><b>ADT-Treatment-Action</b>: <a href="EpisodeOfCare-Tumorerkrankung.html">Generated Summary: MR: 4634834, Patient/Patientin verstorben: Z123456780; status: active; <span title="Codes: {http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl C16213}">Cancer Diagnosis</span></a></p><p><b>status</b>: current</p><p><b>mode</b>: working</p><p><b>code</b>: <span title="Codes: {http://loinc.org 93341-6}">Medication recommendation</span></p><p><b>subject</b>: <a href="Patient-Beispielpatient.html">Generated Summary: id: 654321, id: 876456X123; active; Maximilian Peter Mustermann (OFFICIAL); gender: male; birthDate: 1974-12-25</a></p><h3>Entries</h3><table class="grid"><tr><td>-</td><td><b>Item</b></td></tr><tr><td>*</td><td><a href="#MedicationRequest_RecommendationMedicationRequestExample">See above (MedicationRequest/RecommendationMedicationRequestExample)</a></td></tr></table></div>'
        },
        extension: [
          {
            url: "http://molit.eu/fhir/vitu/StructureDefinition/episode-of-care",
            valueReference: {
              reference: null
            }
          }
        ],
        status: "current",
        mode: "working",
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "93341-6",
              display: "Medication recommendation"
            }
          ]
        },
        subject: {
          reference: null
        },
        entry: [
          {
            item: {
              reference: "MedicationRequest/RecommendationMedicationRequestExample"
            }
          }
        ]
      },
      request: {
        method: "POST",
        url: "List"
      }
    },
    {
      fullUrl: "1972b14c-f952-4e4b-a517-1a67622b5631",
      resource: {
        resourceType: "MedicationRequest",
        id: "RecommendationMedicationRequestExample",
        text: {
          status: "extensions",
          div: '<div xmlns="http://www.w3.org/1999/xhtml"><p><b>Generated Narrative</b></p><p><b>MedicationRecommendationPrio</b>: 1</p><p><b>MedicationRecommendationEvidenceLevel</b>: <span title="Codes: {http://molit.eu/fhir/vitu/CodeSystem/evidence-level m2A}">In einer anderen Tumorentität wurde der prädiktive Wert des Biomarkers oder die klinische Wirksamkeit in einer Biomarker-stratifizierten Kohorte einer adäquat gepowerten prospektiven Studie oder Metaanalyse gezeigt.</span></p><p><b>ADT-Treatment-Action</b>: <a href="EpisodeOfCare-Tumorerkrankung.html">Generated Summary: MR: 4634834, Patient/Patientin verstorben: Z123456780; status: active; <span title="Codes: {http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl C16213}">Cancer Diagnosis</span></a></p><p><b>status</b>: draft</p><p><b>intent</b>: plan</p><p><b>medication</b>: <a name="ContainedMedication"> </a></p><blockquote><blockquote><p><b>ingredient</b></p><p><b>item</b>: <span title="Codes: {http://www.whocc.no/atc L01XX44}">Aflibercept</span></p></blockquote><blockquote><p><b>ingredient</b></p><p><b>item</b>: <span title="Codes: {http://molit.eu/fhir/vitu/CodeSystem/custom-substances new_substance}">new_substance</span></p></blockquote><blockquote><p><b>ingredient</b></p><p><b>item</b>: <span title="Codes: {http://molit.eu/fhir/vitu/CodeSystem/custom-substances selumetinib}">Selumetinib</span></p></blockquote></blockquote><p><b>subject</b>: <a href="Patient-Beispielpatient.html">Generated Summary: id: 654321, id: 876456X123; active; Maximilian Peter Mustermann (OFFICIAL); gender: male; birthDate: 1974-12-25</a></p><p><b>encounter</b>: <a href="Encounter-TMBFall.html">Generated Summary: status: planned; <span title="{http://terminology.hl7.org/CodeSystem/v3-ActCode VR}">virtual</span>; <span title="Codes: {http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl C159520}">Patient Case Review</span></a></p><p><b>authoredOn</b>: 2021-08-16</p><p><b>reasonCode</b>: <span title="Codes: {http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl C28237}">Leitlinie</span>, <span title="Codes: {http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl C35571}">Progrediente Erkrankung</span></p><p><b>reasonReference</b>: </p><ul><li><a href="Observation-GrundDerEmpfehlung01.html">Generated Summary: <span title="Codes: {http://terminology.hl7.org/CodeSystem/observation-category laboratory}">Laboratory</span>; <span title="Codes: {http://hl7.org/fhir/uv/genomics-reporting/CodeSystem/TbdCodes therapeutic-implication}">Therapeutic Implication</span></a></li><li><a href="Observation-GrundDerEmpfehlung02.html">Generated Summary: <span title="Codes: {http://terminology.hl7.org/CodeSystem/observation-category laboratory}">Laboratory</span>; <span title="Codes: {http://hl7.org/fhir/uv/genomics-reporting/CodeSystem/TbdCodes therapeutic-implication}">Therapeutic Implication</span></a></li></ul><p><b>note</b>: Sonstige Empfehlung</p></div>'
        },
        contained: [
          {
            resourceType: "Medication",
            id: "ContainedMedication",
            ingredient: [
              {
                itemCodeableConcept: {
                  coding: [
                    {
                      system: "http://www.whocc.no/atc",
                      code: "L01XX44",
                      display: "Aflibercept"
                    }
                  ]
                }
              },
              {
                itemCodeableConcept: {
                  coding: [
                    {
                      system: "http://molit.eu/fhir/vitu/CodeSystem/custom-substances",
                      code: "new_substance"
                    }
                  ]
                }
              },
              {
                itemCodeableConcept: {
                  coding: [
                    {
                      system: "http://molit.eu/fhir/vitu/CodeSystem/custom-substances",
                      code: "selumetinib",
                      display: "Selumetinib"
                    }
                  ]
                }
              }
            ]
          }
        ],
        extension: [
          {
            url: "http://molit.eu/fhir/vitu/StructureDefinition/MedicationRecommendationPrio",
            valueInteger: undefined
          },
          {
            url: "http://molit.eu/fhir/vitu/StructureDefinition/MedicationRecommendationEvidenceLevel",
            valueCodeableConcept: {
              coding: [
                {
                  system: "http://molit.eu/fhir/vitu/CodeSystem/evidence-level",
                  code: "m2A"
                }
              ]
            }
          },
          {
            url: "http://molit.eu/fhir/vitu/StructureDefinition/episode-of-care",
            valueReference: {
              reference: "EpisodeOfCare/Tumorerkrankung"
            }
          }
        ],
        status: "draft",
        intent: "plan",
        medicationReference: {
          reference: "#ContainedMedication"
        },
        subject: {
          reference: null
        },
        encounter: {
          reference: "Encounter/TMBFall"
        },
        authoredOn: "2021-08-16",
        reasonCode: [
          {
            coding: [
              {
                system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
                code: "C28237",
                display: "Leitlinie"
              }
            ]
          },
          {
            coding: [
              {
                system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
                code: "C35571",
                display: "Progrediente Erkrankung"
              }
            ]
          }
        ],
        reasonReference: [
          {
            reference: "Observation/GrundDerEmpfehlung01"
          },
          {
            reference: "Observation/GrundDerEmpfehlung02"
          }
        ],
        note: [
          {
            text: "Sonstige Empfehlung"
          }
        ]
      },
      request: {
        method: "POST",
        url: "MedicationRequest"
      }
    }
  ]
};

export const recommendationReason = {
  resourceType: "Observation",
  id: "GrundDerEmpfehlung01",
  meta: {
    profile: ["http://hl7.org/fhir/uv/genomics-reporting/StructureDefinition/therapeutic-implication"]
  },
  extension: [
    {
      url: "http://molit.eu/fhir/vitu/StructureDefinition/episode-of-care",
      valueReference: {
        reference: undefined
      }
    }
  ],
  status: "final",
  category: [
    {
      coding: [
        {
          system: "http://terminology.hl7.org/CodeSystem/observation-category",
          code: "laboratory"
        }
      ]
    }
  ],
  code: {
    coding: [
      {
        system: "http://hl7.org/fhir/uv/genomics-reporting/CodeSystem/TbdCodes",
        code: "therapeutic-implication"
      }
    ]
  },
  subject: {
    reference: undefined
  },
  derivedFrom: [],
  component: [
    {
      code: {
        coding: [
          {
            system: "http://loinc.org",
            code: "51963-7"
          }
        ]
      },
      valueCodeableConcept: {
        coding: []
      }
    },
    {
      code: {
        coding: [
          {
            system: "http://hl7.org/fhir/uv/genomics-reporting/CodeSystem/TbdCodes",
            code: "prognostic-implication"
          }
        ]
      },
      valueCodeableConcept: {
        coding: [
          {
            system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            code: "C94226",
            display: "Improvement"
          }
        ]
      }
    }
  ]
};

export const encounterTMBFall = {
  resourceType: "Encounter",
  meta: {
    profile: ["http://molit.eu/fhir/vitu/StructureDefinition/encounter-tumorboard-case"]
  },
  status: "planned",
  class: {
    system: "http://terminology.hl7.org/CodeSystem/v3-ActCode",
    code: "VR"
  },
  type: [
    {
      coding: [
        {
          system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
          code: "C159520",
          display: "Patient Case Review"
        }
      ]
    }
  ],
  episodeOfCare: [
    {
      reference: null
    }
  ],
  subject: {
    reference: null,
    display: null
  },
  partOf: {
    reference: null
  }
};

export const encounterTMBKonferenz = {
  resourceType: "Encounter",
  meta: {
    profile: ["http://molit.eu/fhir/vitu/StructureDefinition/encounter-tmb-konferenz"]
  },
  identifier: [
    {
      system: "http://molit.eu/fhir/vitu/sid/videoRoomId",
      value: null
    }
  ],
  status: "planned",
  class: {
    system: "http://terminology.hl7.org/CodeSystem/v3-ActCode",
    code: "VR"
  },
  type: [
    {
      coding: [
        {
          system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
          code: "C93304",
          display: "Tumor Board Review"
        }
      ]
    }
  ],
  participant: [],
  serviceType: {
    text: null
  },
  period: {
    start: null
  }
};

export const recommendationDocument = {
  resourceType: "DocumentReference",
  meta: {
    profile: ["http://molit.eu/fhir/vitu/StructureDefinition/tumorboard-recommendation"]
  },
  extension: [
    {
      url: "http://molit.eu/fhir/vitu/StructureDefinition/episode-of-care",
      valueReference: {
        reference: null
      }
    }
  ],
  status: "current",
  type: {
    coding: [
      {
        system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        code: "C25197",
        display: "Recommendation"
      }
    ]
  },
  subject: {
    reference: null
  },
  author: [
    {
      reference: null
    }
  ],
  content: [
    {
      attachment: {
        contentType: null,
        url: null
      }
    }
  ]
};
